import { functionType } from '../_util/type';
export function colorPickerProps() {
    return {
        value: { type: [String, Object] },
        defaultValue: { type: [String, Object] },
        format: { type: String },
        defaultFormat: { type: String, default: 'hex' },
        allowClear: { type: Boolean, default: false },
        presets: { type: Array },
        disabled: { type: Boolean, default: undefined },
        disabledAlpha: { type: Boolean, default: false },
        /** Hide format selector (antd ≥ 5.14). */
        disabledFormat: { type: Boolean, default: false },
        open: { type: Boolean, default: undefined },
        trigger: { type: String, default: 'click' },
        placement: { type: String, default: 'bottomLeft' },
        arrow: {
            type: [Boolean, Object],
            default: true,
        },
        showText: {
            type: [Boolean, Function],
            default: false,
        },
        size: { type: String },
        rootClassName: String,
        getPopupContainer: { type: Function },
        /** Custom panel layout (antd ≥ 5.5). Also available as `panelRender` slot. */
        panelRender: functionType(),
        /** @deprecated Please use `destroyOnHidden` instead (antd ≥ 5.25). */
        destroyTooltipOnHide: { type: Boolean, default: false },
        destroyOnHidden: { type: Boolean, default: undefined },
    };
}
